// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"212":"fb073e7f","327":"cf5df19d","631":"1813bf20","672":"898a9cc3","813":"6108410c","908":"ced6dbdf","909":"6f9b34cb"}[chunkId] + ".chunk.js";
};